<div class="status-section" >
        <div [class]="'status-icon-container typography-body-m-light ' + iconClass + ' ' + sectionClass">
            <div [class]="'status-icon typography-body-m-light ' + iconClass">
                <!-- <div class="circle-color" style="width: 10px; height: 10px; border-radius: 12px"></div> -->
            </div>
            <span class="status-span">{{this.statusText}}</span>
        </div>
</div>
